import type { Metric } from 'web-vitals';

import { track } from './analytics';

function sendMetric(metric: Metric) {
  track('Web Vitals', {
    metric: metric.name,
    value: String(Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value)),
    rating: metric.rating,
  });
}

export function reportWebVitals() {
  import('web-vitals').then(({ onCLS, onINP, onLCP, onFCP, onTTFB }) => {
    onCLS(sendMetric);
    onINP(sendMetric);
    onLCP(sendMetric);
    onFCP(sendMetric);
    onTTFB(sendMetric);
  });
}
